import React from 'react'

import styles from './styles.module.scss'

const ArlingtonSection: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>Arlington National Cemetery Services</h2>
        <p className={styles.subtitle}>
          A trusted partner for families and funeral directors across the country navigating
          Arlington National Cemetery with confidence.
        </p>

        <div className={styles.columns}>
          <div className={styles.imageColumn}>
            <img
              src="/veteran-services/arlington-pallbearers.jpg"
              alt="Military pallbearers at Arlington National Cemetery"
              className={styles.image}
            />
          </div>

          <div className={styles.copyColumn}>
            <h3 className={styles.subheading}>A Trusted Local Partner for Arlington Services</h3>
            <p className={styles.body}>
              Located just minutes from Arlington National Cemetery, Kalas Funeral Home &amp;
              Crematory is uniquely positioned to guide families through this process with clarity
              and care.
            </p>
            <p className={styles.body}>
              With over 135 years of experience, we understand the intricacies of Arlington and
              bring a steady, knowledgeable presence to each step, from eligibility and
              documentation to scheduling and military honors.
            </p>
            <p className={styles.body}>
              From the moment arrangements begin, we coordinate directly with your family, your
              local funeral director, and Arlington National Cemetery to ensure every detail is
              handled properly and seamlessly. Our role is to bring structure to the process and
              peace of mind to your family, so you can focus on honoring a life of service.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ArlingtonSection
